import { defineComponent as _defineComponent } from 'vue'
import Input from '@/components/ui/input/Input.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import Button from '@/components/ui/button/Button.vue'
import { computed, inject, ref, watch } from 'vue'
import { ExclusionZoneViewModel } from '../viewmodels/ExclusionZone.viewmodel'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExclusionZoneForm',
  setup(__props) {

const vm = inject<ExclusionZoneViewModel>('exclusion-zone-view-model')!

const title = computed(() =>
	vm.exclusionZone.value?.id ? 'Editar Zona de Exclusão' : 'Cadastrar Zona de Exclusão',
)

const crumbs = [
	{ name: 'Cadastro Zona de Exclusão', step: 1 },
	{ name: 'Definição da área', step: 2 },
]

const step = ref(1)

watch(vm.openForm, (value) => {
	if (value) vm.getMonitoredAreas()
})

return { __sfc: true,vm, title, crumbs, step, Input, Dropdown, Button, Breadcrumb }
}

})